import React from "react";

export default function PrivacyPolicyPage() {

  return <iframe src="https://app.termly.io/policy-viewer/policy.html?policyUUID=17afab85-64a4-411e-8248-3acc224f0214"
                 width="100%"
                 height="15100px" />

}